import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import { RequireAuth } from './auth/RequireAuth';
import { Layout } from './components/Layout';
import { DashboardPage } from './pages/DashboardPage';
import { AgentsListPage } from './pages/AgentsListPage';
import { AgentEditorPage } from './pages/AgentEditorPage';
import { AgentChatPage } from './pages/AgentChatPage';
import { FlowsListPage } from './pages/FlowsListPage';
import { FlowEditorPage } from './pages/FlowEditorPage';
import { KnowledgeBasesPage } from './pages/KnowledgeBasesPage';
import { RunsListPage } from './pages/RunsListPage';
import { RunDetailPage } from './pages/RunDetailPage';
import { BudgetPage } from './pages/BudgetPage';
import { CostsPage } from './pages/CostsPage';
import { ActivitiesPage } from './pages/ActivitiesPage';
import { agentStudioPath } from './lib/routes';

export function AgentStudioApp() {
  return (
    <AuthProvider>
      <Routes>
        <Route
          element={
            <RequireAuth>
              <Layout />
            </RequireAuth>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="agents" element={<AgentsListPage />} />
          <Route path="agents/:id" element={<AgentEditorPage />} />
          <Route path="agents/:id/chat" element={<AgentChatPage />} />
          <Route path="flows" element={<FlowsListPage />} />
          <Route path="flows/:id" element={<FlowEditorPage />} />
          <Route path="templates" element={<Navigate to={agentStudioPath('flows')} replace />} />
          <Route path="knowledge-bases" element={<KnowledgeBasesPage />} />
          <Route path="budget" element={<BudgetPage />} />
          <Route path="costs" element={<CostsPage />} />
          <Route path="activities" element={<ActivitiesPage />} />
          <Route path="runs" element={<RunsListPage />} />
          <Route path="runs/:id" element={<RunDetailPage />} />
          <Route path="*" element={<Navigate to={agentStudioPath()} replace />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export { AgentStudioApp as App };
